import AssetForm from './AssetForm';

export default AssetForm;
export * from './AssetForm';
